import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Center, Tooltip } from "@chakra-ui/react";
import { InfoCircle } from "~/icons";

export const Legalese: FC = () => {
  const { t } = useTranslation();

  return (
    <Tooltip
      hasArrow
      label={t("inviteAFriend.invitee.membershipPayment.legalese")}
      placement="top"
    >
      <Center>
        <InfoCircle color="black" h={4} w={4} />
      </Center>
    </Tooltip>
  );
};
